import MailButton from '@components/MailButton';
import PhoneButton from '@components/PhoneButton';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { IoIosContact } from 'react-icons/io';
import useLocaleSuffix from '@/src/utils/useLocaleSuffix';

export default function ContactSeller({ ad }: { ad: any }) {
  const [showSeller, setShowSeller] = useState(false);
  const t = useTranslations('ContactSeller');
  const getLocaleSuffix = useLocaleSuffix();

  let subjectAndBody: string | undefined;

  if (ad) {
    const subject = encodeURIComponent(
      t('prefilledMailTitle', { id: ad.id, name: ad[getLocaleSuffix('title')] })
    );
    const body = encodeURIComponent(
      t('prefilledMailBody', { id: ad.id, name: ad[getLocaleSuffix('title')] })
    );
    subjectAndBody = `?subject=${subject}&body=${body}`;
  }

  return (
    <div className='p-6'>
      <button
        className='flex w-full items-center justify-center gap-3 rounded-sm border-2 border-dark bg-black px-4 py-2 uppercase text-white hover:bg-brand hover:text-black focus:bg-brand focus:text-black'
        onClick={() => setShowSeller(!showSeller)}
      >
        <span className='text-2xl'>
          <IoIosContact />
        </span>
        {t('buttonText')}
      </button>
      {showSeller && (
        <ul className='flex flex-col gap-1 pt-2'>
          <li>
            <PhoneButton />
          </li>
          <li>
            <MailButton message={subjectAndBody} />
          </li>
        </ul>
      )}
    </div>
  );
}
